import { render, staticRenderFns } from "./ItsSalesInnerDepartDetail.vue?vue&type=template&id=5d51db2a&scoped=true&"
import script from "./ItsSalesInnerDepartDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesInnerDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesInnerDepartDetail.vue?vue&type=style&index=0&id=5d51db2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51db2a",
  null
  
)

export default component.exports